import { AlertTriangle, Info, AlertOctagon } from 'lucide-react';
import type { CalloutBlock } from '../../../types/investigator';

const VARIANT_STYLES: Record<CalloutBlock['variant'], { container: string; icon: typeof Info }> = {
  info:     { container: 'bg-ring/10 border-ring/30 text-ring',             icon: Info },
  warning:  { container: 'bg-warning/10 border-warning/30 text-warning',    icon: AlertTriangle },
  critical: { container: 'bg-destructive/10 border-destructive/30 text-destructive', icon: AlertOctagon },
};

interface CalloutProps {
  block: CalloutBlock;
}

export default function Callout({ block }: CalloutProps) {
  const { container, icon: Icon } = VARIANT_STYLES[block.variant];

  return (
    <div className={`rounded-lg border px-4 py-3 flex gap-3 ${container}`}>
      <Icon className="w-4 h-4 flex-shrink-0 mt-0.5" />
      <div>
        <p className="text-xs font-semibold mb-0.5">{block.title}</p>
        <p className="text-xs opacity-80 leading-relaxed">{block.body}</p>
      </div>
    </div>
  );
}
